export enum ImageDownloadsize{
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  Original = 'original'
}